import script from "./Carousel.vue?vue&type=script&setup=true&lang=js"
export * from "./Carousel.vue?vue&type=script&setup=true&lang=js"

import "./Carousel.vue?vue&type=style&index=0&id=66a484e2&lang=css"

const __exports__ = script;

export default __exports__